import { PageHeader } from '@/components/layout/page-header';
import { MarketsPanel } from '@/features/markets/markets-panel';

// /operations/markets: tab bar + market table. The exchange-wide controls (freeze, killswitch,
// maintenance) live on /devops/exchange.
const MarketsPage = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title="Markets" />
      <MarketsPanel />
    </div>
  );
};
MarketsPage.displayName = 'MarketsPage';

export default MarketsPage;
